var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',_vm._g(_vm._b({attrs:{"variant":"outline"},scopedSlots:_vm._u([_vm._l((_vm.$slots),function(_,slot){return {key:slot,fn:function(){return [_vm._t(slot)]},proxy:true}})],null,true)},'Button',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }